


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyC5YQX8GEXh0BdRYYBTPlDa77ZJ3U6ETKU",
  authDomain: "vinsa-c49dc.firebaseapp.com",
  projectId: "vinsa-c49dc",
  storageBucket: "vinsa-c49dc.firebasestorage.app",
  messagingSenderId: "281616212588",
  appId: "1:281616212588:web:407a8bf535ff5e0d482e49"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export